import React, { ComponentType, FC, ReactNode } from 'react';
import { InfoOutlineIcon, SCP } from 'ia-react-core';
import { StyledDiv, StyledFormMessageText, StyledIcon, StyledMessage } from './InformationsSection.styles';

export interface InformationsSectionProps extends SCP<'div'> {
  informationsLabel: ReactNode;
  Icon?: ComponentType;
  iconAlign?: string;
}

const InformationsSection: FC<InformationsSectionProps> = ({ informationsLabel, Icon = InfoOutlineIcon, iconAlign, ...props }) => (
  <StyledDiv {...props}>
    <StyledMessage $iconAlign={iconAlign}>
      <StyledIcon as={Icon} />
      <StyledFormMessageText>
        {informationsLabel}
      </StyledFormMessageText>
    </StyledMessage>
  </StyledDiv>
);

export default InformationsSection;
